import { fileActions } from "@/store/file";
import type { RootState } from "@/store/types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  BoostrapContext,
  useReducerBoostrap,
} from "../context/boostrap.context";
import { fetchConfig } from "../store/bootstrap";
import { useSelectorRoot } from "@/store/hooks";

const BootstrapSystem = ({ children }: Props): React.ReactElement | null => {
  const value = useReducerBoostrap();
  const dispatch = useDispatch();
  const isSuccess = useSelectorRoot(
    (state: RootState) => state.bootstrap.isSuccess
  );
  const [finishConfig, setFinishConfig] = useState(false);
  // const folderRootId = useSelectorRoot((state: RootState) => state.project.folderRootId);
  useEffect(() => {
    dispatch(fetchConfig());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      setFinishConfig(true);
      // dispatch(fileActions.resetFileState());
      // dispatch(fileActions.getAllFileContent(folderRootId));
    }
  }, [isSuccess]);

  return (
    <BoostrapContext.Provider value={value}>
      {finishConfig ? children : null}
    </BoostrapContext.Provider>
  );
};

export default BootstrapSystem;
